import { render, staticRenderFns } from "./Reel.vue?vue&type=template&id=b36bd15c"
import script from "./Reel.vue?vue&type=script&lang=js"
export * from "./Reel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports